import { nanoid } from '@ant-design/pro-components';
import { Typography, Tabs, TabsProps } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
// icons
import PageWrapper from 'pages/Components/PageWrapper';
import { useTranslation } from 'react-i18next';
import { SYSTEM_TITLE } from 'utils/constants';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from 'base/routes/routes';
import { checkPermission, useCheckPermission } from 'utils/permissionHelper';
import { customerSegmentPresenter, customerSegmentStore } from 'stores/root_store';
import createPageArchives from '.';
import CreateUpdatePage from './CreateUpdatePage';

const { Text } = Typography;

export type TargetKey = React.MouseEvent | React.KeyboardEvent | string;

const createArchivesList = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = 'Kho tài liệu' + ' - ' + SYSTEM_TITLE;

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // lấy id của tab (nếu như có id là tab xem chi tiết)
    const tabId = searchParams.get('tabId');
    const typeTab = searchParams.get('type');
    const tabName = searchParams.get('tabName');

    // ==================================== STATE ===================================================
    const [idTabDetail, setIdtabDetail] = useState(() => {
      if (tabId && typeTab === 'detail') return tabId;
      return undefined;
    });

    const [deleteKey, setDeleteKey] = useState('');

    const CreatePageArchives = createPageArchives();
    // ============================================ XỬ LÝ TABS =========================================

    const [activeKey, setActiveKey] = useState('1');
    const [items, setItems] = useState<TabsProps['items']>([
      {
        label: "Danh sách",
        key: '1',
        closable: false,
        children: <div className="p-3 border border-gray-300 border-t-0 rounded-b-sm">
          <CreatePageArchives />
        </div>,
      },
    ]);

    const onChange = (newActiveKey: string) => {
      setActiveKey(newActiveKey);
    };
    const addNewTab = () => {
      if (items) {
        const newActiveKey = nanoid();
        const newPanes = [...items];
        newPanes.push({
          label: t('btn.create'),
          children: <CreateUpdatePage tabID={newActiveKey as string} onMoveTab={removeKey} />,
          key: newActiveKey,
        });
        setItems(newPanes);
        setActiveKey(newActiveKey);
        navigate(ROUTES.UTILITIES.ARCHIVES.LINK + `?type=create`);
      }
    };
    const addTabDetail = async () => {
      if (items && tabId) {
        const newKey = tabId as string;
        const newPanes = [...items];
        const hasDetail = newPanes.find((i) => i.key === tabId);
        if (!hasDetail) {

          newPanes.push({
            label: <>
              <Text
                style={{ width: 100, color: "black !important" }}
                ellipsis={{ tooltip: tabName }
                }
              >
                {tabName}
              </Text>
            </>,
            children: <CreateUpdatePage onMoveTab={removeKey} archivesId={tabId as string} />,
            key: newKey,
          });
          setItems(newPanes);
        }
        setActiveKey(newKey);
      }
    };

    const remove = (targetKey: TargetKey) => {
      if (items && items.length > 2) {
        let newActiveKey = activeKey;
        let lastIndex = -1;
        items.forEach((item, i) => {
          if (item.key === targetKey) {
            lastIndex = i - 1;
          }
        });
        const newPanes = items.filter((item) => item.key !== targetKey);
        if (newPanes.length && newActiveKey === targetKey) {
          if (lastIndex >= 0) {
            if (lastIndex > 0) {
              newActiveKey = newPanes[lastIndex].key;
            } else {
              newActiveKey = newPanes[newPanes.length - 1].key;
            }
          } else {
            newActiveKey = newPanes[0].key;
          }
        }
        setItems(newPanes);
        setActiveKey(newActiveKey);
      } else {
        setItems(
          [
            {
              label: "Danh sách",
              key: '1',
              closable: false,
              children: <div className="p-3 border border-gray-300 border-t-0 rounded-b-sm">
                <CreatePageArchives />
              </div>,
            },
          ]
        )
        setActiveKey('1');
        navigate(ROUTES.UTILITIES.ARCHIVES.LINK);
      }
    };

    const onEdit = (targetKey: React.MouseEvent | React.KeyboardEvent | string, action: 'add' | 'remove') => {
      if (action === 'add') {
        addNewTab();
      } else {
        remove(targetKey);
      }
    };

    const removeKey = (targetKey: string) => {
      setDeleteKey(targetKey);
    };

    useEffect(() => {
      if (typeTab) {
        switch (typeTab) {
          case 'create': {
            // if (checkPermission('CREATE'))
            addNewTab();
            // else navigate(ROUTES.CUSTOMER.CUSTOMER_SEGMENTATION.LINK);
            break;
          }
          case 'detail':
            addTabDetail();
            break;
          default:
            break;
        }
      } else {
        navigate(ROUTES.UTILITIES.ARCHIVES.LINK);
      }
    }, [tabId, typeTab]);

    useEffect(() => {
      if (deleteKey) {
        remove(deleteKey);
      }
    }, [deleteKey]);

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: 'Kho tài liệu',
          },
        ]}
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <Tabs
            activeKey={activeKey}
            // type={checkPermission('CREATE') ? 'editable-card' : 'card'}
            type={'editable-card'}
            size={'small'}
            onEdit={onEdit}
            onChange={onChange}
            hideAdd={true}
            items={items}
            className={
              'h-full [&_.ant-tabs-tab]:!rounded-t-sm [&_.ant-tabs-tab]:!text-default [&_.ant-tabs-tab]:!font-semibold [&_.ant-tabs-tab:hover]:!text-primary [&_.ant-tabs-tab]:!border-gray-300 [&>.ant-tabs-nav_.ant-tabs-tab]:!bg-gray-200 ' +
              '[&>.ant-tabs-nav_.ant-tabs-tab.ant-tabs-tab-active]:!bg-white [&_.ant-tabs-tab-active]:!border-b-white [&_.ant-tabs-tab-active>div]:!text-primary [&_.ant-tabs-nav]:!mb-0 [&_.ant-tabs-nav::before]:!border-b-gray-300 ' +
              '[&_.ant-tabs-nav-add]:!border [&_.ant-tabs-nav-add]:!border-gray-300 '
            }
          />
        </BoxContainer>
      </PageWrapper>
    );
  });
};

export default createArchivesList;
